// Single registry for the clinical imagery used on procedure pages.
//
// The English routes and the Spanish (/es) routes point at the same asset
// records, so a new diagram or an updated graph shows up in both languages.
// Alt text and captions carry per-language strings; anything added here must
// supply both.
import { bypassGraphResponsive, bandDiagramResponsive, refluxPostResponsive } from "@/lib/service-responsive";

import sleeveDiagramJpg800 from "@/assets/sleeve-gastrectomy-v2-800.jpg.asset.json";
import sleeveDiagramJpg1200 from "@/assets/sleeve-gastrectomy-v2-1200.jpg.asset.json";
import sleeveDiagramJpg1536 from "@/assets/sleeve-gastrectomy-v2-1536.jpg.asset.json";
import sleeveDiagramWebp800 from "@/assets/sleeve-gastrectomy-v2-800.webp.asset.json";
import sleeveDiagramWebp1200 from "@/assets/sleeve-gastrectomy-v2-1200.webp.asset.json";
import sleeveDiagramWebp1536 from "@/assets/sleeve-gastrectomy-v2-1536.webp.asset.json";
import sleeveDiagramEsJpg800 from "@/assets/sleeve-gastrectomy-es-v2-800.jpg.asset.json";
import sleeveDiagramEsJpg1200 from "@/assets/sleeve-gastrectomy-es-v2-1200.jpg.asset.json";
import sleeveDiagramEsJpg1536 from "@/assets/sleeve-gastrectomy-es-v2-1536.jpg.asset.json";
import sleeveDiagramEsWebp800 from "@/assets/sleeve-gastrectomy-es-v2-800.webp.asset.json";
import sleeveDiagramEsWebp1200 from "@/assets/sleeve-gastrectomy-es-v2-1200.webp.asset.json";
import sleeveDiagramEsWebp1536 from "@/assets/sleeve-gastrectomy-es-v2-1536.webp.asset.json";
import sleeveGraph from "@/assets/sleeve-excess-weight-loss-percentage-graph.png.asset.json";
import sleeveGraphWebp from "@/assets/sleeve-excess-weight-loss-percentage-graph.webp.asset.json";
import sleeveGraph720 from "@/assets/sleeve-excess-weight-loss-percentage-graph-720.png.asset.json";
import sleeveGraphWebp720 from "@/assets/sleeve-excess-weight-loss-percentage-graph-720.webp.asset.json";
import sleeveFitzer1 from "@/assets/sleeve-fitzer-1.png.asset.json";
import sleeveFitzer1Webp from "@/assets/sleeve-fitzer-1.webp.asset.json";
import sleeveFitzer2 from "@/assets/sleeve-fitzer-2.png.asset.json";
import sleeveFitzer2Webp from "@/assets/sleeve-fitzer-2.webp.asset.json";
import sleeveFitzer3 from "@/assets/sleeve-fitzer-3.jpg.asset.json";
import sleeveFitzer3Webp from "@/assets/sleeve-fitzer-3.webp.asset.json";
import sleeveAmateur1 from "@/assets/sleeve-amateur-1.jpg.asset.json";
import sleeveAmateur1Webp from "@/assets/sleeve-amateur-1.webp.asset.json";
import sleeveAmateur2 from "@/assets/sleeve-amateur-2.png.asset.json";
import sleeveAmateur2Webp from "@/assets/sleeve-amateur-2.webp.asset.json";
import sleeveAmateur3 from "@/assets/sleeve-amateur-3.png.asset.json";
import sleeveAmateur3Webp from "@/assets/sleeve-amateur-3.webp.asset.json";
import sleeveAmateur1Jpg220 from "@/assets/sleeve-amateur-1-220.jpg.asset.json";
import sleeveAmateur1Webp220 from "@/assets/sleeve-amateur-1-220.webp.asset.json";
import sleeveAmateur1Jpg440 from "@/assets/sleeve-amateur-1-440.jpg.asset.json";
import sleeveAmateur1Webp440 from "@/assets/sleeve-amateur-1-440.webp.asset.json";
import sleeveAmateur2Png220 from "@/assets/sleeve-amateur-2-220.png.asset.json";
import sleeveAmateur2Webp220 from "@/assets/sleeve-amateur-2-220.webp.asset.json";
import sleeveAmateur2Png440 from "@/assets/sleeve-amateur-2-440.png.asset.json";
import sleeveAmateur2Webp440 from "@/assets/sleeve-amateur-2-440.webp.asset.json";
import sleeveAmateur3Png220 from "@/assets/sleeve-amateur-3-220.png.asset.json";
import sleeveAmateur3Webp220 from "@/assets/sleeve-amateur-3-220.webp.asset.json";
import sleeveAmateur3Png440 from "@/assets/sleeve-amateur-3-440.png.asset.json";
import sleeveAmateur3Webp440 from "@/assets/sleeve-amateur-3-440.webp.asset.json";
import sleeveFitzer1Png220 from "@/assets/sleeve-fitzer-1-220.png.asset.json";
import sleeveFitzer1Webp220 from "@/assets/sleeve-fitzer-1-220.webp.asset.json";
import sleeveFitzer1Png440 from "@/assets/sleeve-fitzer-1-440.png.asset.json";
import sleeveFitzer1Webp440 from "@/assets/sleeve-fitzer-1-440.webp.asset.json";
import sleeveFitzer2Png220 from "@/assets/sleeve-fitzer-2-220.png.asset.json";
import sleeveFitzer2Webp220 from "@/assets/sleeve-fitzer-2-220.webp.asset.json";
import sleeveFitzer2Png440 from "@/assets/sleeve-fitzer-2-440.png.asset.json";
import sleeveFitzer2Webp440 from "@/assets/sleeve-fitzer-2-440.webp.asset.json";
import sleeveFitzer3Jpg220 from "@/assets/sleeve-fitzer-3-220.jpg.asset.json";
import sleeveFitzer3Webp220 from "@/assets/sleeve-fitzer-3-220.webp.asset.json";
import sleeveFitzer3Jpg440 from "@/assets/sleeve-fitzer-3-440.jpg.asset.json";
import sleeveFitzer3Webp440 from "@/assets/sleeve-fitzer-3-440.webp.asset.json";
import sleeveRefluxNormal from "@/assets/reflux-stomach-before.png.asset.json";
import sleeveRefluxNormalWebp from "@/assets/reflux-stomach-before.webp.asset.json";
import sleeveRefluxPostSleeve from "@/assets/reflux-sleeve-after.png.asset.json";
import sleeveRefluxPostSleeveWebp from "@/assets/reflux-sleeve-after.webp.asset.json";
import bypassDiagramJpg800 from "@/assets/gastric-bypass-v2-800.jpg.asset.json";
import bypassDiagramJpg1200 from "@/assets/gastric-bypass-v2-1200.jpg.asset.json";
import bypassDiagramJpg1536 from "@/assets/gastric-bypass-v2-1536.jpg.asset.json";
import bypassDiagramWebp800 from "@/assets/gastric-bypass-v2-800.webp.asset.json";
import bypassDiagramWebp1200 from "@/assets/gastric-bypass-v2-1200.webp.asset.json";
import bypassDiagramWebp1536 from "@/assets/gastric-bypass-v2-1536.webp.asset.json";
import bypassDiagramEsJpg800 from "@/assets/gastric-bypass-es-v2-800.jpg.asset.json";
import bypassDiagramEsJpg1200 from "@/assets/gastric-bypass-es-v2-1200.jpg.asset.json";
import bypassDiagramEsJpg1536 from "@/assets/gastric-bypass-es-v2-1536.jpg.asset.json";
import bypassDiagramEsWebp800 from "@/assets/gastric-bypass-es-v2-800.webp.asset.json";
import bypassDiagramEsWebp1200 from "@/assets/gastric-bypass-es-v2-1200.webp.asset.json";
import bypassDiagramEsWebp1536 from "@/assets/gastric-bypass-es-v2-1536.webp.asset.json";
import bypassGraph from "@/assets/bypass-weight-loss-graph.png.asset.json";
import bypassGraphWebp from "@/assets/bypass-weight-loss-graph.webp.asset.json";
import pouchRevisionJpg1200 from "@/assets/revision-hub-annotated-1200.jpg.asset.json";
import pouchRevisionWebp1200 from "@/assets/revision-hub-annotated-1200.webp.asset.json";
import pouchContrastJpg800 from "@/assets/dilated-pouch-contrast-800.jpg.asset.json";
import pouchContrastJpg980 from "@/assets/dilated-pouch-contrast-980.jpg.asset.json";
import pouchContrastWebp800 from "@/assets/dilated-pouch-contrast-800.webp.asset.json";
import pouchContrastWebp980 from "@/assets/dilated-pouch-contrast-980.webp.asset.json";
import pouchBlueEsJpg480 from "@/assets/dilated-pouch-boxed-es-480.jpg.asset.json";
import pouchBlueEsJpg800 from "@/assets/dilated-pouch-boxed-es-800.jpg.asset.json";
import pouchBlueEsJpg980 from "@/assets/dilated-pouch-boxed-es-980.jpg.asset.json";
import pouchBlueEsWebp480 from "@/assets/dilated-pouch-boxed-es-480.webp.asset.json";
import pouchBlueEsWebp800 from "@/assets/dilated-pouch-boxed-es-800.webp.asset.json";
import pouchBlueEsWebp980 from "@/assets/dilated-pouch-boxed-es-980.webp.asset.json";
import normalPouchEnJpg480 from "@/assets/bypass-normal-boxed-en-480.jpg.asset.json";
import normalPouchEnJpg796 from "@/assets/bypass-normal-boxed-en-796.jpg.asset.json";
import normalPouchEnWebp480 from "@/assets/bypass-normal-boxed-en-480.webp.asset.json";
import normalPouchEnWebp796 from "@/assets/bypass-normal-boxed-en-796.webp.asset.json";
import normalPouchEsJpg480 from "@/assets/bypass-normal-boxed-es-480.jpg.asset.json";
import normalPouchEsJpg796 from "@/assets/bypass-normal-boxed-es-796.jpg.asset.json";
import normalPouchEsWebp480 from "@/assets/bypass-normal-boxed-es-480.webp.asset.json";
import normalPouchEsWebp796 from "@/assets/bypass-normal-boxed-es-796.webp.asset.json";
import checkpointJpg from "@/assets/checkpoint-charlie.jpg.asset.json";
import checkpointWebp from "@/assets/checkpoint-charlie.webp.asset.json";
import homeHero from "@/assets/hero-1280.webp.asset.json";
import homeDoctor from "@/assets/dr-fitzer-home-900.webp.asset.json";
import bandDiagram from "@/assets/lap-band-diagram.jpg.asset.json";
import bandDiagramWebp from "@/assets/lap-band-diagram.webp.asset.json";
import bandRemovedJpg1200 from "@/assets/lap-band-removed-1200.jpg.asset.json";
import bandRemovedWebp1200 from "@/assets/lap-band-removed-1200.webp.asset.json";
import bandRemovedJpg1600 from "@/assets/lap-band-removed-1600.jpg.asset.json";
import bandRemovedWebp1600 from "@/assets/lap-band-removed-1600.webp.asset.json";
import bandTubingJpg1200 from "@/assets/band-tubing-1200.jpg.asset.json";
import bandTubingWebp1200 from "@/assets/band-tubing-1200.webp.asset.json";
import bandTubingJpg1600 from "@/assets/band-tubing-1600.jpg.asset.json";
import bandTubingWebp1600 from "@/assets/band-tubing-1600.webp.asset.json";
import bandRemovedJpg800 from "@/assets/lap-band-removed-800.jpg.asset.json";
import bandTubingJpg800 from "@/assets/band-tubing-800.jpg.asset.json";
import bandRemovedWebp800 from "@/assets/lap-band-removed-800.webp.asset.json";
import bandTubingWebp800 from "@/assets/band-tubing-800.webp.asset.json";
import bandDilatedEsophagusAnnotatedJpg800 from "@/assets/band-dilated-esophagus-annotated-800.jpg.asset.json";
import bandDilatedEsophagusAnnotatedJpg1268 from "@/assets/band-dilated-esophagus-annotated-1268.jpg.asset.json";
import bandDilatedEsophagusAnnotatedWebp800 from "@/assets/band-dilated-esophagus-annotated-800.webp.asset.json";
import bandDilatedEsophagusAnnotatedWebp1268 from "@/assets/band-dilated-esophagus-annotated-1268.webp.asset.json";
import bypassResectionEn from "@/assets/bypass-revision-resection-en.png.asset.json";
import bypassResectionEnWebp1200 from "@/assets/bypass-revision-resection-en-1200.webp.asset.json";
import bypassResectionEnWebp800 from "@/assets/bypass-revision-resection-en-800.webp.asset.json";
import bypassResectionEnWebp480 from "@/assets/bypass-revision-resection-en-480.webp.asset.json";
import bypassResectionEs from "@/assets/bypass-revision-resection-es.png.asset.json";
import bypassResectionEsWebp1200 from "@/assets/bypass-revision-resection-es-1200.webp.asset.json";
import bypassResectionEsWebp800 from "@/assets/bypass-revision-resection-es-800.webp.asset.json";
import bypassResectionEsWebp480 from "@/assets/bypass-revision-resection-es-480.webp.asset.json";
import pouchRevisionJpg800 from "@/assets/revision-hub-annotated-800.jpg.asset.json";
import sleeveNormalRevision from "@/assets/sleeve-normal-revision.png.asset.json";
import sleeveNormalRevisionJpg480 from "@/assets/sleeve-normal-revision-480.jpg.asset.json";
import sleeveNormalRevisionJpg800 from "@/assets/sleeve-normal-revision-800.jpg.asset.json";
import sleeveNormalRevisionWebp480 from "@/assets/sleeve-normal-revision-480.webp.asset.json";
import sleeveNormalRevisionWebp800 from "@/assets/sleeve-normal-revision-800.webp.asset.json";
import sleeveDissectionRevision from "@/assets/sleeve-dissection-revision.png.asset.json";
import sleeveDissectionRevisionJpg480 from "@/assets/sleeve-dissection-revision-480.jpg.asset.json";
import sleeveDissectionRevisionJpg800 from "@/assets/sleeve-dissection-revision-800.jpg.asset.json";
import sleeveDissectionRevisionWebp480 from "@/assets/sleeve-dissection-revision-480.webp.asset.json";
import sleeveDissectionRevisionWebp800 from "@/assets/sleeve-dissection-revision-800.webp.asset.json";
import sleeveUgiNormalJpg800 from "@/assets/sleeve-ugi-normal-800.jpg.asset.json";
import sleeveUgiNormalJpg1145 from "@/assets/sleeve-ugi-normal-1145.jpg.asset.json";
import sleeveUgiNormalWebp800 from "@/assets/sleeve-ugi-normal-800.webp.asset.json";
import sleeveUgiNormalWebp1145 from "@/assets/sleeve-ugi-normal-1145.webp.asset.json";
import sleeveUgiDilatedJpg800 from "@/assets/sleeve-ugi-dilated-800.jpg.asset.json";
import sleeveUgiDilatedJpg1448 from "@/assets/sleeve-ugi-dilated-1448.jpg.asset.json";
import sleeveUgiDilatedWebp800 from "@/assets/sleeve-ugi-dilated-800.webp.asset.json";
import sleeveUgiDilatedWebp1448 from "@/assets/sleeve-ugi-dilated-1448.webp.asset.json";
import sleeveUgiRefluxPreJpg800 from "@/assets/sleeve-ugi-reflux-pre-800.jpg.asset.json";
import sleeveUgiRefluxPreJpg899 from "@/assets/sleeve-ugi-reflux-pre-899.jpg.asset.json";
import sleeveUgiRefluxPreWebp800 from "@/assets/sleeve-ugi-reflux-pre-800.webp.asset.json";
import sleeveUgiRefluxPreWebp899 from "@/assets/sleeve-ugi-reflux-pre-899.webp.asset.json";
import sleeveUgiRefluxPostJpg736 from "@/assets/sleeve-ugi-reflux-post-736.jpg.asset.json";
import sleeveUgiRefluxPostWebp736 from "@/assets/sleeve-ugi-reflux-post-736.webp.asset.json";
import sleeveUgiRefluxPreEsJpg800 from "@/assets/sleeve-ugi-reflux-pre-800-es.jpg.asset.json";
import sleeveUgiRefluxPreEsWebp800 from "@/assets/sleeve-ugi-reflux-pre-800-es.webp.asset.json";
import sleeveUgiRefluxPreEsJpg899 from "@/assets/sleeve-ugi-reflux-pre-899-es.jpg.asset.json";
import sleeveUgiRefluxPreEsWebp899 from "@/assets/sleeve-ugi-reflux-pre-899-es.webp.asset.json";
import sleeveUgiRefluxPostEsJpg800 from "@/assets/sleeve-ugi-reflux-post-800-es.jpg.asset.json";
import sleeveUgiRefluxPostEsWebp800 from "@/assets/sleeve-ugi-reflux-post-800-es.webp.asset.json";
import sleeveUgiRefluxPostEsJpg1206 from "@/assets/sleeve-ugi-reflux-post-1206-es.jpg.asset.json";
import sleeveUgiRefluxPostEsWebp1206 from "@/assets/sleeve-ugi-reflux-post-1206-es.webp.asset.json";
import hiatalNormalJpg800 from "@/assets/hiatal-normal-800.jpg.asset.json";
import hiatalNormalJpg1536 from "@/assets/hiatal-normal-1536.jpg.asset.json";
import hiatalNormalWebp1200 from "@/assets/hiatal-normal-1200.webp.asset.json";
import hiatalType1Jpg800 from "@/assets/hiatal-type-1-800.jpg.asset.json";
import hiatalType1Jpg1536 from "@/assets/hiatal-type-1-1536.jpg.asset.json";
import hiatalType1Webp1200 from "@/assets/hiatal-type-1-1200.webp.asset.json";
import hiatalType2Jpg800 from "@/assets/hiatal-type-2-v2-800.jpg.asset.json";
import hiatalType2Jpg1536 from "@/assets/hiatal-type-2-v2-1536.jpg.asset.json";
import hiatalType2Webp1200 from "@/assets/hiatal-type-2-v2-1200.webp.asset.json";
import hiatalType3Jpg800 from "@/assets/hiatal-type-3-v2-800.jpg.asset.json";
import hiatalType3Jpg1536 from "@/assets/hiatal-type-3-v2-1536.jpg.asset.json";
import hiatalType3Webp1200 from "@/assets/hiatal-type-3-v2-1200.webp.asset.json";
import hiatalType4Jpg800 from "@/assets/hiatal-type-4-v2-800.jpg.asset.json";
import hiatalType4Jpg1536 from "@/assets/hiatal-type-4-v2-1536.jpg.asset.json";
import hiatalType4Webp1200 from "@/assets/hiatal-type-4-v2-1200.webp.asset.json";

const SITE_ORIGIN = "https://virginiabariatric.com";

export type MediaLang = "en" | "es";

export interface ProcedureMedia {
  /**
   * Canonical (largest) variant. Also the URL used for schema.org ImageObject
   * nodes and image sitemap entries, so it must stay paired with width/height.
   */
  src: string;
  /**
   * Optional smaller variant used only for the <img src> attribute, so clients
   * that ignore srcSet do not download the largest file. Never used for schema.
   */
  fallbackSrc?: string;
  /** Tiny base64 WebP shown as a blurred background while the photo loads. */
  blurDataUrl?: string;
  webp: string;
  srcSet?: string;
  webpSrcSet?: string;
  width: number;
  height: number;
  alt: Record<MediaLang, string>;
  caption: Record<MediaLang, string>;
  /**
   * True when the figure was created by the doctor with AI assistance; the
   * ImageObject creator/creditText then say so instead of crediting the
   * practice as the sole creator.
   */
  aiAssisted?: boolean;
}

export const PROCEDURE_MEDIA = {
  sleeveDiagram: {
    aiAssisted: true,
    src: sleeveDiagramJpg1536.url,
    fallbackSrc: sleeveDiagramJpg800.url,
    srcSet: `${sleeveDiagramJpg800.url} 800w, ${sleeveDiagramJpg1200.url} 1200w, ${sleeveDiagramJpg1536.url} 1536w`,
    webp: sleeveDiagramWebp1536.url,
    webpSrcSet: `${sleeveDiagramWebp800.url} 800w, ${sleeveDiagramWebp1200.url} 1200w, ${sleeveDiagramWebp1536.url} 1536w`,
    width: 1536,
    height: 1024,
    alt: {
      en: "Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve",
      es: "Diagrama médico de una gastrectomía laparoscópica en manga que muestra la parte extraída del estómago y la manga gástrica estrecha",
    },
    caption: {
      en: "Laparoscopic sleeve gastrectomy (VSG)",
      es: "Gastrectomía laparoscópica en manga (VSG)",
    },
  },
  sleeveDiagramEs: {
    aiAssisted: true,
    src: sleeveDiagramEsJpg1536.url,
    fallbackSrc: sleeveDiagramEsJpg800.url,
    srcSet: `${sleeveDiagramEsJpg800.url} 800w, ${sleeveDiagramEsJpg1200.url} 1200w, ${sleeveDiagramEsJpg1536.url} 1536w`,
    webp: sleeveDiagramEsWebp1536.url,
    webpSrcSet: `${sleeveDiagramEsWebp800.url} 800w, ${sleeveDiagramEsWebp1200.url} 1200w, ${sleeveDiagramEsWebp1536.url} 1536w`,
    width: 1536,
    height: 1024,
    alt: {
      en: "Spanish-labeled medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve",
      es: "Diagrama médico en español de una gastrectomía laparoscópica en manga que muestra la parte extraída del estómago y la manga gástrica estrecha",
    },
    caption: {
      en: "Laparoscopic sleeve gastrectomy (VSG)",
      es: "Gastrectomía laparoscópica en manga (VSG)",
    },
  },
  sleeveGraph: {
    src: sleeveGraph.url,
    webp: sleeveGraphWebp.url,
    fallbackSrc: sleeveGraph720.url,
    srcSet: `${sleeveGraph720.url} 720w, ${sleeveGraph.url} 1920w`,
    webpSrcSet: `${sleeveGraphWebp720.url} 720w, ${sleeveGraphWebp.url} 1920w`,
    width: 1920,
    height: 780,
    alt: {
      en: "Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 10 years",
      es: "Porcentaje promedio de pérdida del exceso de peso después de la manga gástrica laparoscópica en Virginia Bariatric Surgery, de 1 mes a 10 años",
    },
    caption: {
      en: "Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 10 years.",
      es: "Porcentaje promedio de pérdida del exceso de peso de los pacientes de manga gástrica del Dr. Fitzer, de 1 mes a 10 años.",
    },
  },
  sleeveFitzer1: {
    src: sleeveFitzer1.url,
    fallbackSrc: sleeveFitzer1Png220.url,
    srcSet: `${sleeveFitzer1Png220.url} 220w, ${sleeveFitzer1Png440.url} 440w, ${sleeveFitzer1.url} 680w`,
    webp: sleeveFitzer1Webp.url,
    webpSrcSet: `${sleeveFitzer1Webp220.url} 220w, ${sleeveFitzer1Webp440.url} 440w, ${sleeveFitzer1Webp.url} 680w`,
    width: 680,
    height: 680,
    alt: {
      en: "Upper GI contrast study of a properly narrowed gastric sleeve created by Dr. Fitzer at Virginia Bariatric Surgery",
      es: "Estudio con contraste de una manga gástrica correctamente angosta realizada por el Dr. Fitzer en Virginia Bariatric Surgery",
    },
    caption: {
      en: "Upper GI contrast study — properly sized sleeve by Dr. Fitzer.",
      es: "Estudio con contraste: manga del tamaño correcto hecha por el Dr. Fitzer.",
    },
  },
  sleeveFitzer2: {
    src: sleeveFitzer2.url,
    fallbackSrc: sleeveFitzer2Png220.url,
    srcSet: `${sleeveFitzer2Png220.url} 220w, ${sleeveFitzer2Png440.url} 440w, ${sleeveFitzer2.url} 823w`,
    webp: sleeveFitzer2Webp.url,
    webpSrcSet: `${sleeveFitzer2Webp220.url} 220w, ${sleeveFitzer2Webp440.url} 440w, ${sleeveFitzer2Webp.url} 823w`,
    width: 823,
    height: 823,
    alt: {
      en: "Post-operative imaging of a slim, tubular gastric sleeve after laparoscopic sleeve gastrectomy by Dr. Fitzer",
      es: "Imagen posoperatoria de una manga gástrica delgada y tubular después de una manga laparoscópica hecha por el Dr. Fitzer",
    },
    caption: {
      en: "Slim, tubular sleeve anatomy — Dr. Fitzer, Northern Virginia.",
      es: "Anatomía delgada y tubular de la manga: Dr. Fitzer, norte de Virginia.",
    },
  },
  sleeveFitzer3: {
    src: sleeveFitzer3.url,
    fallbackSrc: sleeveFitzer3Jpg220.url,
    srcSet: `${sleeveFitzer3Jpg220.url} 220w, ${sleeveFitzer3Jpg440.url} 440w, ${sleeveFitzer3.url} 833w`,
    webp: sleeveFitzer3Webp.url,
    webpSrcSet: `${sleeveFitzer3Webp220.url} 220w, ${sleeveFitzer3Webp440.url} 440w, ${sleeveFitzer3Webp.url} 833w`,
    width: 833,
    height: 833,
    alt: {
      en: "Contrast imaging of a Dr. Fitzer sleeve gastrectomy showing correct narrow diameter along the entire staple line",
      es: "Imagen con contraste de una manga gástrica del Dr. Fitzer con el diámetro angosto correcto en toda la línea de grapas",
    },
    caption: {
      en: "Narrow diameter along the entire staple line.",
      es: "Diámetro angosto en toda la línea de grapas.",
    },
  },
  sleeveAmateur1: {
    src: sleeveAmateur1.url,
    fallbackSrc: sleeveAmateur1Jpg220.url,
    srcSet: `${sleeveAmateur1Jpg220.url} 220w, ${sleeveAmateur1Jpg440.url} 440w, ${sleeveAmateur1.url} 829w`,
    webp: sleeveAmateur1Webp.url,
    webpSrcSet: `${sleeveAmateur1Webp220.url} 220w, ${sleeveAmateur1Webp440.url} 440w, ${sleeveAmateur1Webp.url} 829w`,
    width: 829,
    height: 829,
    alt: {
      en: "Dilated, over-large sleeve gastrectomy referred to Dr. Fitzer for revisional bariatric surgery",
      es: "Manga gástrica dilatada y demasiado grande referida al Dr. Fitzer para cirugía bariátrica de revisión",
    },
    caption: {
      en: "Dilated sleeve referred for revision.",
      es: "Manga dilatada referida para revisión.",
    },
  },
  sleeveAmateur2: {
    src: sleeveAmateur2.url,
    fallbackSrc: sleeveAmateur2Png220.url,
    srcSet: `${sleeveAmateur2Png220.url} 220w, ${sleeveAmateur2Png440.url} 440w, ${sleeveAmateur2.url} 1167w`,
    webp: sleeveAmateur2Webp.url,
    webpSrcSet: `${sleeveAmateur2Webp220.url} 220w, ${sleeveAmateur2Webp440.url} 440w, ${sleeveAmateur2Webp.url} 1167w`,
    width: 1167,
    height: 1167,
    alt: {
      en: "Upper GI study showing an incomplete 'trimmed' sleeve gastrectomy with retained fundus, sent to Dr. Fitzer for repair",
      es: "Estudio que muestra una manga gástrica incompleta con fundus retenido, enviada al Dr. Fitzer para su corrección",
    },
    caption: {
      en: "Incomplete \u201ctrim\u201d with retained fundus.",
      es: "Recorte incompleto con fundus retenido.",
    },
  },
  sleeveAmateur3: {
    src: sleeveAmateur3.url,
    fallbackSrc: sleeveAmateur3Png220.url,
    srcSet: `${sleeveAmateur3Png220.url} 220w, ${sleeveAmateur3Png440.url} 440w, ${sleeveAmateur3.url} 685w`,
    webp: sleeveAmateur3Webp.url,
    webpSrcSet: `${sleeveAmateur3Webp220.url} 220w, ${sleeveAmateur3Webp440.url} 440w, ${sleeveAmateur3Webp.url} 685w`,
    width: 685,
    height: 685,
    alt: {
      en: "CT scan of an oversized post-sleeve stomach with poor restriction, evaluated by Dr. Fitzer for sleeve revision surgery",
      es: "Tomografía de un estómago demasiado grande tras una manga, con poca restricción, evaluado por el Dr. Fitzer para cirugía de revisión",
    },
    caption: {
      en: "Oversized post-sleeve stomach — poor restriction.",
      es: "Estómago demasiado grande tras la manga: poca restricción.",
    },
  },
  sleeveRefluxNormal: {
    src: sleeveRefluxNormal.url,
    webp: sleeveRefluxNormalWebp.url,
    width: 1335,
    height: 682,
    alt: {
      en: "Medical illustration of a patient with a normal stomach lying flat on their back, showing the stomach, esophagus, and gastroesophageal junction with fluid remaining in the stomach and no reflux",
      es: "Ilustración médica de un paciente con estómago normal acostado boca arriba, mostrando el estómago, el esófago y la unión gastroesofágica con el líquido en el estómago y sin reflujo",
    },
    caption: {
      en: "Patient with normal stomach sleeping flat on back",
      es: "Paciente con estómago normal acostado boca arriba",
    },
  },
  sleeveRefluxPostSleeve: {
    src: sleeveRefluxPostSleeve.url,
    webp: sleeveRefluxPostSleeveWebp.url,
    width: 1335,
    height: 682,
    alt: {
      en: "Medical illustration of a sleeve gastrectomy patient lying flat on their back, showing the tubular stomach, swallowed liquid within the sleeve, and refluxed liquid in the esophagus",
      es: "Ilustración médica de un paciente con manga gástrica acostado boca arriba, mostrando el estómago tubular, el líquido dentro de la manga y el líquido reflujado en el esófago",
    },
    caption: {
      en: "Sleeve gastrectomy patient sleeping flat on back (supine)",
      es: "Paciente con manga gástrica acostado boca arriba (supino)",
    },
  },
  bypassDiagram: {
    aiAssisted: true,
    src: bypassDiagramJpg1536.url,
    fallbackSrc: bypassDiagramJpg800.url,
    srcSet: `${bypassDiagramJpg800.url} 800w, ${bypassDiagramJpg1200.url} 1200w, ${bypassDiagramJpg1536.url} 1536w`,
    webp: bypassDiagramWebp1536.url,
    webpSrcSet: `${bypassDiagramWebp800.url} 800w, ${bypassDiagramWebp1200.url} 1200w, ${bypassDiagramWebp1536.url} 1536w`,
    width: 1536,
    height: 1024,
    alt: {
      en: "Medical diagram of Roux-en-Y gastric bypass anatomy showing the small pouch and rerouted small intestine",
      es: "Diagrama médico del bypass gástrico en Y de Roux que muestra la bolsa gástrica pequeña y el intestino delgado reconectado",
    },
    caption: {
      en: "Laparoscopic Roux-en-Y gastric bypass showing the small gastric pouch, bypassed stomach, and rerouted small intestine.",
      es: "Bypass gástrico laparoscópico en Y de Roux que muestra la bolsa gástrica pequeña, el estómago excluido y el intestino delgado reconectado.",
    },
  },
  bypassDiagramEs: {
    aiAssisted: true,
    src: bypassDiagramEsJpg1536.url,
    fallbackSrc: bypassDiagramEsJpg800.url,
    srcSet: `${bypassDiagramEsJpg800.url} 800w, ${bypassDiagramEsJpg1200.url} 1200w, ${bypassDiagramEsJpg1536.url} 1536w`,
    webp: bypassDiagramEsWebp1536.url,
    webpSrcSet: `${bypassDiagramEsWebp800.url} 800w, ${bypassDiagramEsWebp1200.url} 1200w, ${bypassDiagramEsWebp1536.url} 1536w`,
    width: 1536,
    height: 1024,
    alt: {
      en: "Medical diagram labeled in Spanish showing laparoscopic Roux-en-Y gastric bypass anatomy",
      es: "Diagrama médico en español del bypass gástrico laparoscópico en Y de Roux, con la bolsa gástrica pequeña y el intestino delgado reconectado",
    },
    caption: {
      en: "Spanish-labeled laparoscopic Roux-en-Y gastric bypass showing the small gastric pouch, bypassed stomach, and rerouted small intestine.",
      es: "Bypass gástrico laparoscópico en Y de Roux que muestra la bolsa gástrica pequeña, el estómago excluido y el intestino delgado reconectado.",
    },
  },
  bypassGraph: {
    src: bypassGraph.url,
    webp: bypassGraphWebp.url,
    fallbackSrc: bypassGraphResponsive.src,
    webpSrcSet: bypassGraphResponsive.srcSet,
    width: 1664,
    height: 652,
    alt: {
      en: "Excess weight loss percentage after Roux-en-Y gastric bypass at Virginia Bariatric Surgery, from 1 month through 10 years post-surgery",
      es: "Porcentaje de pérdida del exceso de peso después del bypass gástrico en Y de Roux en Virginia Bariatric Surgery, de 1 mes a 10 años tras la cirugía",
    },
    caption: {
      en: "Excess weight loss percentage after Roux-en-Y gastric bypass at Virginia Bariatric Surgery, from 1 month through 10 years post-surgery.",
      es: "Porcentaje de pérdida del exceso de peso de los pacientes de bypass gástrico del Dr. Fitzer, de 1 mes a 10 años tras la cirugía.",
    },
  },
  bandDiagram: {
    src: bandDiagram.url,
    webp: bandDiagramWebp.url,
    fallbackSrc: bandDiagramResponsive.src,
    webpSrcSet: bandDiagramResponsive.srcSet,
    width: 900,
    height: 1055,
    alt: {
      en: "Medical illustration of an adjustable gastric band (LAP-BAND) placed around the top of the stomach with its tubing and fill port",
      es: "Ilustración médica de una banda gástrica ajustable (LAP-BAND) colocada alrededor de la parte superior del estómago, con su tubo y su puerto de ajuste",
    },
    caption: {
      en: "Schematic of the adjustable gastric band",
      es: "Esquema de la banda gástrica ajustable",
    },
  },
  bandTubing: {
    src: bandTubingJpg1600.url,
    fallbackSrc: bandTubingJpg800.url,
    blurDataUrl:
      "data:image/webp;base64,UklGRn4AAABXRUJQVlA4IHIAAAAwBACdASoUAAsAPu1iqU2ppaQiMAgBMB2JagCdMoR3ABn3Xm0xhGimZIAA/tGfRcADG7UV5Yr+ArECsaYL7tx8kyv+RDP4AQFb7HURfjq0ICXtlmuJTcQbud8NPeBTHAVLGciQuiEH7T8MQKuA3IaioAA=",
    webp: bandTubingWebp1600.url,
    srcSet: `${bandTubingJpg800.url} 800w, ${bandTubingJpg1200.url} 1200w, ${bandTubingJpg1600.url} 1600w`,
    webpSrcSet: `${bandTubingWebp800.url} 800w, ${bandTubingWebp1200.url} 1200w, ${bandTubingWebp1600.url} 1600w`,
    width: 1600,
    height: 899,
    alt: {
      en: "Laparoscopic view of band tubing under tension, hammocked around the root of the small intestine, in a patient with chronic intestinal obstruction",
      es: "Vista laparoscópica del tubo de una banda gástrica bajo tensión, enredado como una hamaca alrededor de la raíz del intestino delgado, en un paciente con obstrucción intestinal crónica",
    },
    caption: {
      en: "Dr. Fitzer prepares to remove a band in a patient with chronic intestinal obstruction caused by the tubing. The tubing is under tension because it had become hammocked around the root of the small intestine.",
      es: "El Dr. Fitzer se prepara para retirar una banda en un paciente con obstrucción intestinal crónica causada por el tubo. El tubo está bajo tensión porque quedó enredado como una hamaca alrededor de la raíz del intestino delgado.",
    },
  },
  bandRemoved: {
    src: bandRemovedJpg1600.url,
    fallbackSrc: bandRemovedJpg800.url,
    blurDataUrl:
      "data:image/webp;base64,UklGRn4AAABXRUJQVlA4IHIAAABQBACdASoUAAsAPu1iqU2ppaOiMAgBMB2JaACdMoADQY0+hoRZTxenUvfIAP7dcceAbsRvQExgeGg90Y6fDAiNxWBWMGaw+n93+TjNn0Kpi3fOpUtZCoZUfMYa3I2Y5yEl4YVpQrz0zv/MOf6sVR6wAAA=",
    webp: bandRemovedWebp1600.url,
    srcSet: `${bandRemovedJpg800.url} 800w, ${bandRemovedJpg1200.url} 1200w, ${bandRemovedJpg1600.url} 1600w`,
    webpSrcSet: `${bandRemovedWebp800.url} 800w, ${bandRemovedWebp1200.url} 1200w, ${bandRemovedWebp1600.url} 1600w`,
    width: 1600,
    height: 898,
    alt: {
      en: "A LAP-BAND removed by Dr. Fitzer and separated into four pieces",
      es: "Una LAP-BAND retirada por el Dr. Fitzer y separada en cuatro piezas",
    },
    caption: {
      en: "A LAP-BAND removed by Dr. Fitzer, in four pieces.",
      es: "Una LAP-BAND retirada por el Dr. Fitzer, en cuatro piezas.",
    },
  },
  bandDilatedEsophagus: {
    aiAssisted: true,
    src: bandDilatedEsophagusAnnotatedJpg1268.url,
    fallbackSrc: bandDilatedEsophagusAnnotatedJpg800.url,
    blurDataUrl:
      "data:image/webp;base64,UklGRrAAAABXRUJQVlA4IKQAAABQBQCdASoYABcAPxGAt1WsKCUjKAgBgCIJaQATx4DXgxudFHsiBz0FwDh2t3KT4sP0kAAA/u1hPouAim+9rS2MbXb8yiTRd4CHMFqLrR9rECHbzcDIo+sNoDFKGg8Nmvu+EQrIDA5Q46pmkrt2LMWARvNd3h1T2ange0WFqk1UxFCOQr1Zu80ryoAKB9jzKcvlyWce+InhflNpqe3cQDR0eAAAAA==",
    webp: bandDilatedEsophagusAnnotatedWebp1268.url,
    srcSet: `${bandDilatedEsophagusAnnotatedJpg800.url} 800w, ${bandDilatedEsophagusAnnotatedJpg1268.url} 1268w`,
    webpSrcSet: `${bandDilatedEsophagusAnnotatedWebp800.url} 800w, ${bandDilatedEsophagusAnnotatedWebp1268.url} 1268w`,
    width: 1268,
    height: 1240,
    alt: {
      en: "Upper GI contrast study of a LAP-BAND patient showing a dilated esophagus, pouch above the band, narrow contrast passage through the band, and contrast in the stomach",
      es: "Estudio gastrointestinal superior con contraste de un paciente con LAP-BAND que muestra un esófago dilatado, la bolsa encima de la banda, el paso estrecho del contraste y contraste en el estómago",
    },
    caption: {
      en: 'Upper GI series test in a LAP-BAND patient who has pain on swallowing and reflux. The arrows indicate: (1) a very dilated esophagus, (2) the pouch above the band, (3) the LAP-BAND itself, (4) a "string sign," or narrow ribbon of contrast flowing through an overly tight band, and (5) a bit of contrast that made it to the stomach proper.',
      es: 'Estudio de la serie gastrointestinal superior de un paciente con LAP-BAND que presenta dolor al tragar y reflujo. Las flechas señalan: (1) un esófago muy dilatado, (2) la bolsa por encima de la banda, (3) la propia LAP-BAND, (4) el «signo del hilo», una cinta estrecha de contraste que atraviesa una banda demasiado ajustada, y (5) un poco de contraste que llegó al estómago propiamente dicho.',
    },
  },
  sleeveNormalRevision: {
    src: sleeveNormalRevision.url,
    fallbackSrc: sleeveNormalRevisionJpg800.url,
    webp: sleeveNormalRevisionWebp800.url,
    srcSet: `${sleeveNormalRevisionJpg480.url} 480w, ${sleeveNormalRevisionJpg800.url} 800w`,
    webpSrcSet: `${sleeveNormalRevisionWebp480.url} 480w, ${sleeveNormalRevisionWebp800.url} 800w`,
    width: 800,
    height: 499,
    alt: {
      en: "Laparoscopic view of a normal gastric sleeve outlined in blue during gallbladder surgery five years after sleeve gastrectomy",
      es: "Vista laparoscópica de una manga gástrica normal delineada en azul durante una cirugía de vesícula cinco años después de la gastrectomía en manga",
    },
    caption: {
      en: "A normal sleeve is visualized in one of Dr. Fitzer's patients during gallbladder surgery five years after the sleeve operation. The sleeve (blue outline) retains a proper, tubular shape.",
      es: "Se visualiza una manga normal en una paciente del Dr. Fitzer durante una cirugía de vesícula cinco años después de la operación de manga. La manga (delineada en azul) conserva una forma tubular adecuada.",
    },
  },
  sleeveStretchedRevision: {
    src: sleeveDissectionRevision.url,
    fallbackSrc: sleeveDissectionRevisionJpg800.url,
    webp: sleeveDissectionRevisionWebp800.url,
    srcSet: `${sleeveDissectionRevisionJpg480.url} 480w, ${sleeveDissectionRevisionJpg800.url} 800w`,
    webpSrcSet: `${sleeveDissectionRevisionWebp480.url} 480w, ${sleeveDissectionRevisionWebp800.url} 800w`,
    width: 976,
    height: 544,
    alt: {
      en: "Laparoscopic view of an excessively large gastric sleeve outlined by a dashed line being dissected during revision surgery",
      es: "Vista laparoscópica de una manga gástrica excesivamente grande, contorneada con línea punteada, durante la disección en una cirugía de revisión",
    },
    caption: {
      en: "The excessively large sleeve (outlined by dashed line) being dissected.",
      es: "La manga excesivamente grande (contorneada con línea punteada) durante la disección.",
    },
  },
  sleeveUgiNormalEn: {
    aiAssisted: true,
    src: sleeveUgiNormalJpg1145.url,
    fallbackSrc: sleeveUgiNormalJpg800.url,
    webp: sleeveUgiNormalWebp1145.url,
    srcSet: `${sleeveUgiNormalJpg800.url} 800w, ${sleeveUgiNormalJpg1145.url} 1145w`,
    webpSrcSet: `${sleeveUgiNormalWebp800.url} 800w, ${sleeveUgiNormalWebp1145.url} 1145w`,
    width: 1145,
    height: 1374,
    alt: {
      en: "Upper GI series of a normally sized gastric sleeve in a Dr. Fitzer patient, distended with gas from effervescent crystals and annotated with labels for the esophagus, lower esophageal sphincter, cardia, sleeve body, pylorus, and stomach antrum",
      es: "Serie gastrointestinal superior de una manga gástrica de tamaño normal en un paciente del Dr. Fitzer, distendida con gas de cristales efervescentes y anotada con rótulos para el esófago, el esfínter esofágico inferior, el cardias, el cuerpo de la manga, el píloro y el antro gástrico",
    },
    caption: {
      en: "An upper GI series from a Dr. Fitzer sleeve patient with mediocre weight loss. During the study, the patient consumed a swallow of effervescent crystals, which release carbon dioxide gas. The gas distends the sleeve so we can evaluate its true size, which is normal in this case.",
      es: "Serie gastrointestinal superior de un paciente de manga gástrica del Dr. Fitzer con una pérdida de peso mediocre. Durante el estudio, el paciente ingirió un trago de cristales efervescentes, que liberan gas de dióxido de carbono. El gas distiende la manga para que podamos evaluar su tamaño real, que en este caso es normal.",
    },
  },
  sleeveUgiDilatedEn: {
    aiAssisted: true,
    src: sleeveUgiDilatedJpg1448.url,
    fallbackSrc: sleeveUgiDilatedJpg800.url,
    webp: sleeveUgiDilatedWebp1448.url,
    srcSet: `${sleeveUgiDilatedJpg800.url} 800w, ${sleeveUgiDilatedJpg1448.url} 1448w`,
    webpSrcSet: `${sleeveUgiDilatedWebp800.url} 800w, ${sleeveUgiDilatedWebp1448.url} 1448w`,
    width: 1448,
    height: 1086,
    alt: {
      en: "Upper GI series of a dilated gastric sleeve after surgery performed in Mexico, distended with gas from effervescent crystals and annotated with labels for the lower esophageal sphincter, cardia, stomach antrum, and the dilated sleeve",
      es: "Serie gastrointestinal superior de una manga gástrica dilatada después de una cirugía realizada en México, distendida con gas de cristales efervescentes y anotada con rótulos para el esfínter esofágico inferior, el cardias, el antro gástrico y la manga dilatada",
    },
    caption: {
      en: "This patient presented with weight regain after a sleeve performed in Mexico. Inflation of the sleeve thanks to the same effervescent crystals makes it easy to appreciate that this sleeve is much larger than it should be. The patient had an excellent weight loss result after a resleeve operation.",
      es: "Esta paciente acudió con recuperación de peso después de una manga realizada en México. La inflación de la manga gracias a los mismos cristales efervescentes hace fácil apreciar que esta manga es mucho más grande de lo que debería ser. La paciente tuvo un excelente resultado de pérdida de peso después de la operación de remanga.",
    },
  },
  sleeveUgiRefluxPreEn: {
    aiAssisted: true,
    src: sleeveUgiRefluxPreJpg899.url,
    fallbackSrc: sleeveUgiRefluxPreJpg800.url,
    webp: sleeveUgiRefluxPreWebp899.url,
    srcSet: `${sleeveUgiRefluxPreJpg800.url} 800w, ${sleeveUgiRefluxPreJpg899.url} 899w`,
    webpSrcSet: `${sleeveUgiRefluxPreWebp800.url} 800w, ${sleeveUgiRefluxPreWebp899.url} 899w`,
    width: 899,
    height: 880,
    alt: {
      en: "Upper GI series of a sleeve patient with a small hiatal hernia and severe reflux, labeled with the esophagus, lower esophageal sphincter, sleeve, and pylorus, showing contrast and a small pouch of the sleeve above the diaphragm",
      es: "Serie gastrointestinal superior de un paciente con manga gástrica con una hernia hiatal pequeña y reflujo grave, con rótulos para el esófago, el esfínter esofágico inferior, la manga y el píloro, que muestra contraste y una pequeña porción de la manga por encima del diafragma",
    },
    caption: {
      en: 'Upper GI series of a patient with a small hiatal hernia and severe reflux after a sleeve. Notice that the LES and a small pouch of the sleeve are visible above the diaphragm (marked with small arrows). The "REFLUX" label and arrow were placed by the radiologist who conducted the study. Reflux is severe; it almost gets to the mouth.',
      es: "Serie gastrointestinal superior de un paciente con una hernia hiatal pequeña y reflujo grave después de una manga. Nótese que el EEI y una pequeña porción de la manga son visibles por encima del diafragma (señalados con flechas pequeñas). La etiqueta «REFLUX» y la flecha las colocó el radiólogo que realizó el estudio. El reflujo es grave; casi llega a la boca.",
    },
  },
  sleeveUgiRefluxPostEn: {
    aiAssisted: true,
    src: sleeveUgiRefluxPostJpg736.url,
    webp: sleeveUgiRefluxPostWebp736.url,
    fallbackSrc: sleeveUgiRefluxPostJpg736.url,
    webpSrcSet: refluxPostResponsive.srcSet,
    width: 736,
    height: 634,
    alt: {
      en: "Repeat upper GI series after hiatal hernia repair and conversion to gastric bypass, labeled with the esophagus, lower esophageal sphincter, and small intestine, showing the entire gastric pouch below the diaphragm with no reflux",
      es: "Nueva serie gastrointestinal superior después de la reparación de la hernia hiatal y la conversión a bypass gástrico, con rótulos para el esófago, el esfínter esofágico inferior y el intestino delgado, que muestra todo el reservorio gástrico por debajo del diafragma y sin reflujo",
    },
    caption: {
      en: "Repeat UGI series after repair of hiatal hernia and conversion to bypass. Note that the entire gastric pouch is now well below the edge of the diaphragm shadow. Also note that there is no reflux. The pouch is again full, but the esophagus remains empty. The patient reported immediate and complete relief from reflux.",
      es: "Nueva serie gastrointestinal superior después de la reparación de la hernia hiatal y la conversión a bypass. Nótese que todo el reservorio gástrico está ahora bien por debajo del borde de la silueta del diafragma. Nótese también que no hay reflujo. El reservorio vuelve a estar lleno, pero el esófago permanece vacío. El paciente refirió alivio inmediato y completo del reflujo.",
    },
  },
  sleeveUgiRefluxPreEs: {
    aiAssisted: true,
    src: sleeveUgiRefluxPreEsJpg899.url,
    fallbackSrc: sleeveUgiRefluxPreEsJpg800.url,
    webp: sleeveUgiRefluxPreEsWebp899.url,
    srcSet: `${sleeveUgiRefluxPreEsJpg800.url} 800w, ${sleeveUgiRefluxPreEsJpg899.url} 899w`,
    webpSrcSet: `${sleeveUgiRefluxPreEsWebp800.url} 800w, ${sleeveUgiRefluxPreEsWebp899.url} 899w`,
    width: 899,
    height: 880,
    alt: {
      en: "Upper GI series of a sleeve patient with a small hiatal hernia and severe reflux, labeled with the esophagus, lower esophageal sphincter, sleeve, and pylorus, showing contrast and a small pouch of the sleeve above the diaphragm",
      es: "Serie gastrointestinal superior de un paciente con manga gástrica con una hernia hiatal pequeña y reflujo grave, con rótulos para el esófago, el esfínter esofágico inferior, la manga y el píloro, que muestra contraste y una pequeña porción de la manga por encima del diafragma",
    },
    caption: {
      en: 'Upper GI series of a patient with a small hiatal hernia and severe reflux after a sleeve. Notice that the LES and a small pouch of the sleeve are visible above the diaphragm (marked with small arrows). The "REFLUX" label and arrow were placed by the radiologist who conducted the study. Reflux is severe; it almost gets to the mouth.',
      es: "Serie gastrointestinal superior de un paciente con una hernia hiatal pequeña y reflujo grave después de una manga. Nótese que el EEI y una pequeña porción de la manga son visibles por encima del diafragma (señalados con flechas pequeñas). La etiqueta «REFLUX» y la flecha las colocó el radiólogo que realizó el estudio. El reflujo es grave; casi llega a la boca.",
    },
  },
  sleeveUgiRefluxPostEs: {
    aiAssisted: true,
    src: sleeveUgiRefluxPostEsJpg1206.url,
    fallbackSrc: sleeveUgiRefluxPostEsJpg800.url,
    webp: sleeveUgiRefluxPostEsWebp1206.url,
    srcSet: `${sleeveUgiRefluxPostEsJpg800.url} 800w, ${sleeveUgiRefluxPostEsJpg1206.url} 1206w`,
    webpSrcSet: `${sleeveUgiRefluxPostEsWebp800.url} 800w, ${sleeveUgiRefluxPostEsWebp1206.url} 1206w`,
    width: 1206,
    height: 1305,
    alt: {
      en: "Repeat upper GI series after hiatal hernia repair and conversion to gastric bypass, labeled with the esophagus, lower esophageal sphincter, and small intestine, showing the entire gastric pouch below the diaphragm with no reflux",
      es: "Nueva serie gastrointestinal superior después de la reparación de la hernia hiatal y la conversión a bypass gástrico, con rótulos para el esófago, el esfínter esofágico inferior y el intestino delgado, que muestra todo el reservorio gástrico por debajo del diafragma y sin reflujo",
    },
    caption: {
      en: "Repeat UGI series after repair of hiatal hernia and conversion to bypass. Note that the entire gastric pouch is now well below the edge of the diaphragm shadow. Also note that there is no reflux. The pouch is again full, but the esophagus remains empty. The patient reported immediate and complete relief from reflux.",
      es: "Nueva serie gastrointestinal superior después de la reparación de la hernia hiatal y la conversión a bypass. Nótese que todo el reservorio gástrico está ahora bien por debajo del borde de la silueta del diafragma. Nótese también que no hay reflujo. El reservorio vuelve a estar lleno, pero el esófago permanece vacío. El paciente refirió alivio inmediato y completo del reflujo.",
    },
  },
  revisionPouchContrastEs: {
    src: pouchContrastJpg980.url,
    fallbackSrc: pouchContrastJpg800.url,
    webp: pouchContrastWebp980.url,
    srcSet: `${pouchContrastJpg800.url} 800w, ${pouchContrastJpg980.url} 980w`,
    webpSrcSet: `${pouchContrastWebp800.url} 800w, ${pouchContrastWebp980.url} 980w`,
    width: 980,
    height: 957,
    alt: {
      en: "Upper GI contrast study of a dilated gastric bypass pouch filled with gas, with contrast in the small intestine",
      es: "Estudio gastrointestinal superior con contraste: reservorio dilatado de un bypass gástrico lleno de gas, con contraste en el intestino delgado",
    },
    caption: {
      en: "Stretched pouch in a gastric bypass patient twelve years and two term pregnancies after the initial surgery. The oral contrast has mostly flowed into the small intestine, leaving the pouch filled with CO2 (gas) released by the effervescent crystals swallowed as part of the test.",
      es: "Reservorio dilatado de una paciente con bypass gástrico, doce años y dos embarazos a término después de la cirugía inicial. El contraste oral ha pasado casi por completo al intestino delgado y el reservorio quedó lleno de CO2 (gas) liberado por los cristales efervescentes ingeridos para la prueba.",
    },
  },
  revisionPouchAnnotatedEs: {
    src: pouchBlueEsJpg980.url,
    fallbackSrc: pouchBlueEsJpg480.url,
    webp: pouchBlueEsWebp980.url,
    srcSet: `${pouchBlueEsJpg480.url} 480w, ${pouchBlueEsJpg800.url} 800w, ${pouchBlueEsJpg980.url} 980w`,
    webpSrcSet: `${pouchBlueEsWebp480.url} 480w, ${pouchBlueEsWebp800.url} 800w, ${pouchBlueEsWebp980.url} 980w`,
    blurDataUrl: "data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAABQBACdASoUABQAPxGCuFWsKKUjKAgBgCIJZwAALnZFmdX9iu2Su+EeejQAAPauphOpz0L1R8NMwukZ8FVv8QC9AT1GCkIRGVV7xg6NrvysgPUO6iZMWJM4Xv4/zc0BIcUAAA==",
    width: 980,
    height: 957,
    alt: {
      en: "Spanish-labeled upper GI study with blue arrows identifying the esophagus and small intestine and a blue outline of the dilated gastric bypass pouch",
      es: "Estudio gastrointestinal superior anotado en español con flechas azules que señalan el esófago y el intestino delgado, y un contorno azul del reservorio dilatado del bypass gástrico",
    },
    caption: {
      en: "Same pouch, now annotated by Dr. Fitzer. The pouch is outlined in blue.",
      es: "El mismo reservorio, ahora anotado por el Dr. Fitzer. El reservorio está delineado en azul. Un reservorio normal tiene aproximadamente el mismo ancho que el esófago, por lo que este es claramente más grande de lo debido. La paciente volvió a perder peso adecuadamente después de la revisión.",
    },
  },
  revisionPouchNormalEn: {
    aiAssisted: true,
    src: normalPouchEnJpg796.url,
    fallbackSrc: normalPouchEnJpg480.url,
    webp: normalPouchEnWebp796.url,
    srcSet: `${normalPouchEnJpg480.url} 480w, ${normalPouchEnJpg796.url} 796w`,
    webpSrcSet: `${normalPouchEnWebp480.url} 480w, ${normalPouchEnWebp796.url} 796w`,
    width: 796,
    height: 796,
    alt: {
      en: "Annotated upper GI study of a normal gastric bypass showing the esophagus, lower esophageal sphincter, narrow pouch, small intestine, and triangles marking the top edge of the diaphragm",
      es: "Estudio gastrointestinal superior anotado de un bypass gástrico normal que muestra el esófago, el esfínter esofágico inferior, el reservorio, el intestino delgado y el borde superior del diafragma",
    },
    caption: {
      en: "A normal gastric bypass pouch. The width of the pouch is comparable to that of the esophagus. The triangles mark the topmost edge of the diaphragm.",
      es: "Un reservorio normal de bypass gástrico. El ancho del reservorio es comparable al del esófago. Los triángulos señalan el borde superior del diafragma.",
    },
  },
  revisionPouchNormalEs: {
    aiAssisted: true,
    src: normalPouchEsJpg796.url,
    fallbackSrc: normalPouchEsJpg480.url,
    webp: normalPouchEsWebp796.url,
    srcSet: `${normalPouchEsJpg480.url} 480w, ${normalPouchEsJpg796.url} 796w`,
    webpSrcSet: `${normalPouchEsWebp480.url} 480w, ${normalPouchEsWebp796.url} 796w`,
    width: 796,
    height: 796,
    alt: {
      en: "Spanish-labeled upper GI study of a normal gastric bypass showing the esophagus, lower esophageal sphincter, narrow pouch, small intestine, and diaphragm edge",
      es: "Estudio gastrointestinal superior de un bypass gástrico normal con rótulos en español del esófago, esfínter esofágico inferior, reservorio de tamaño adecuado, intestino delgado y borde superior del diafragma",
    },
    caption: {
      en: "A normal gastric bypass pouch. The width of the pouch is comparable to that of the esophagus. The triangles mark the topmost edge of the diaphragm.",
      es: "Un reservorio normal de bypass gástrico. El ancho del reservorio es comparable al del esófago. Los triángulos señalan el borde superior del diafragma.",
    },
  },
  revisionPouch: {
    src: bypassResectionEn.url,
    webp: bypassResectionEnWebp1200.url,
    webpSrcSet: `${bypassResectionEnWebp480.url} 480w, ${bypassResectionEnWebp800.url} 800w, ${bypassResectionEnWebp1200.url} 1200w`,
    width: 1200,
    height: 866,
    alt: {
      en: "Laparoscopic gastric bypass pouch revision showing the large excess pouch being resected and the new smaller pouch with a sizer bougie inside",
      es: "Revisión laparoscópica del reservorio de bypass gástrico que muestra la resección de la gran porción sobrante y el nuevo reservorio más pequeño con una sonda calibradora dentro",
    },
    caption: {
      en: "This patient’s gastric bypass pouch dilated after two term pregnancies. Dr. Fitzer performed a laparoscopic revision, resecting the excess pouch and creating a new, smaller pouch sized with a bougie.",
      es: "A esta paciente se le dilató la bolsa gástrica del bypass después de dos embarazos de término. El Dr. Fitzer hizo una revisión laparoscópica: resecó la bolsa excedente y creó una bolsa nueva, más pequeña, calibrada con una bujía.",
    },
  },
  revisionPouchEs: {
    src: bypassResectionEs.url,
    webp: bypassResectionEsWebp1200.url,
    webpSrcSet: `${bypassResectionEsWebp480.url} 480w, ${bypassResectionEsWebp800.url} 800w, ${bypassResectionEsWebp1200.url} 1200w`,
    width: 1200,
    height: 866,
    alt: {
      en: "Spanish-labeled laparoscopic gastric bypass pouch revision showing excess pouch resection and the new smaller pouch with a sizer bougie inside",
      es: "Revisión laparoscópica del reservorio de bypass gástrico con rótulos en español que muestra la resección de la gran porción sobrante y el nuevo reservorio más pequeño con una sonda calibradora dentro",
    },
    caption: {
      en: "This patient’s gastric bypass pouch dilated after two term pregnancies. Dr. Fitzer performed a laparoscopic revision, resecting the excess pouch and creating a new, smaller pouch sized with a bougie.",
      es: "A esta paciente se le dilató el reservorio gástrico del bypass después de dos embarazos a término. El Dr. Fitzer realizó una revisión laparoscópica: resecó el reservorio sobrante y creó uno nuevo, más pequeño, calibrado con una sonda.",
    },
  },
  revisionHub: {
    src: pouchRevisionJpg1200.url,
    fallbackSrc: pouchRevisionJpg800.url,
    blurDataUrl:
      "data:image/webp;base64,UklGRn4AAABXRUJQVlA4IHIAAACwBACdASoUAAsAPu1iqU2ppaOiMAgBMB2JbACdMoRwACxjkh7YAJR/fGTl5UkAAP7sx0s7eA/mu6p2WLiu5S0HzZs9/Gl0obBXdr+EgiGfxFR1hasG5N03wO8q+Q/MC7N2s9Xkj53Jl9rLnHuqIC1gAAA=",
    webp: pouchRevisionWebp1200.url,
    width: 1200,
    height: 668,
    alt: {
      en: "Laparoscopic view before gastric bypass revision showing a dilated pouch marked with a blue arrow and a large hiatal hernia marked with a blue circle",
      es: "Vista laparoscópica antes de una revisión de bypass gástrico que muestra una bolsa gástrica dilatada marcada con una flecha azul y una hernia hiatal grande marcada con un círculo azul",
    },
    caption: {
      en: "Dr. Fitzer prepares to perform a revision for a patient with unacceptable weight loss and severe heartburn. They have a dilated pouch (blue arrow) and a large hiatal hernia that needs to be repaired (blue circle).",
      es: "El Dr. Fitzer se prepara para realizar una revisión a un paciente con una pérdida de peso inaceptable y acidez estomacal grave. Tiene una bolsa gástrica dilatada (flecha azul) y una hernia hiatal grande que necesita ser reparada (círculo azul).",
    },
  },
  hiatalNormal: {
    src: hiatalNormalJpg1536.url,
    fallbackSrc: hiatalNormalJpg800.url,
    webp: hiatalNormalWebp1200.url,
    width: 1536,
    height: 915,
    alt: {
      en: "Medical illustration of normal anatomy: the esophagus passes through a snug opening (hiatus) in the diaphragm to reach the stomach.",
      es: "Ilustración médica de la anatomía normal: el esófago atraviesa una abertura ajustada, llamada hiato, en el diafragma para llegar al estómago.",
    },
    caption: {
      en: "Normal anatomy. The hiatus — the opening in the diaphragm — fits the esophagus snugly.",
      es: "Anatomía normal. El hiato —la abertura del diafragma— se ajusta alrededor del esófago.",
    },
  },
  hiatalType1: {
    src: hiatalType1Jpg1536.url,
    fallbackSrc: hiatalType1Jpg800.url,
    webp: hiatalType1Webp1200.url,
    width: 1536,
    height: 916,
    alt: {
      en: "Medical illustration of a type I (sliding) hiatal hernia: a small portion of the upper stomach slides up through the diaphragm's hiatus.",
      es: "Ilustración médica de una hernia hiatal tipo I o deslizante: una pequeña porción de la parte superior del estómago sube a través del hiato del diafragma.",
    },
    caption: {
      en: "Type I hiatal hernia (sliding). A small portion of the stomach slides up through the hiatus.",
      es: "Hernia hiatal tipo I (deslizante). Una pequeña porción del estómago sube a través del hiato.",
    },
  },
  hiatalType2: {
    src: hiatalType2Jpg1536.url,
    fallbackSrc: hiatalType2Jpg800.url,
    webp: hiatalType2Webp1200.url,
    width: 1536,
    height: 1024,
    alt: {
      en: "Medical illustration of a type II (paraesophageal) hiatal hernia: the esophagus stays in place while part of the stomach slides up alongside it.",
      es: "Ilustración médica de una hernia hiatal tipo II o paraesofágica: el esófago permanece en su lugar mientras parte del estómago sube a su lado.",
    },
    caption: {
      en: "Type II hiatal hernia (paraesophageal). The esophagus stays in place while part of the stomach slides up alongside it.",
      es: "Hernia hiatal tipo II (paraesofágica). El esófago permanece en su lugar mientras parte del estómago sube a su lado.",
    },
  },
  hiatalType3: {
    src: hiatalType3Jpg1536.url,
    fallbackSrc: hiatalType3Jpg800.url,
    webp: hiatalType3Webp1200.url,
    width: 1536,
    height: 1024,
    alt: {
      en: "Medical illustration of a type III (mixed) hiatal hernia: the esophagus and stomach both migrate into the chest above the diaphragm.",
      es: "Ilustración médica de una hernia hiatal tipo III o mixta: el esófago y el estómago se desplazan hacia el tórax por encima del diafragma.",
    },
    caption: {
      en: "Type III hiatal hernia (mixed). A significant portion of the stomach herniates into the chest alongside the esophagus.",
      es: "Hernia hiatal tipo III (mixta). Una porción importante del estómago se hernia hacia el tórax junto al esófago.",
    },
  },
  hiatalType4: {
    src: hiatalType4Jpg1536.url,
    fallbackSrc: hiatalType4Jpg800.url,
    webp: hiatalType4Webp1200.url,
    width: 1536,
    height: 915,
    alt: {
      en: "Medical illustration of a type IV hiatal hernia: the stomach and a loop of transverse colon herniate through the diaphragm.",
      es: "Ilustración médica de una hernia hiatal tipo IV: el estómago y un asa del colon transverso se hernian a través del diafragma.",
    },
    caption: {
      en: "Type IV hiatal hernia. The stomach and other organs — here, a loop of transverse colon — herniate through the diaphragm.",
      es: "Hernia hiatal tipo IV. El estómago y otros órganos —en este caso, un asa del colon transverso— se hernian a través del diafragma.",
    },
  },
  checkpointCharlie: {
    src: checkpointJpg.url,
    webp: checkpointWebp.url,
    width: 1200,
    height: 900,
    alt: {
      en: "The preserved US Army guard house at Checkpoint Charlie in Berlin, used here as a visual metaphor for the two insurance coverage checkpoints.",
      es: "La caseta de vigilancia del Ejército de los Estados Unidos conservada en el Checkpoint Charlie de Berlín, usada aquí como metáfora visual de los dos puntos de control de la cobertura del seguro.",
    },
    caption: {
      en: "Checkpoint Charlie, Berlin — clearing one checkpoint did not get you past the next.",
      es: "Checkpoint Charlie, Berlín: pasar un punto de control no lo dejaba pasar el siguiente.",
    },
  },
  homeHero: {
    src: homeHero.url,
    webp: homeHero.url,
    width: 1280,
    height: 840,
    alt: {
      en: "Dr. Matthew Fitzer, bariatric surgeon serving Northern Virginia — Virginia Bariatric Surgery",
      es: "El Dr. Matthew Fitzer, cirujano bariátrico que atiende el norte de Virginia — Virginia Bariatric Surgery",
    },
    caption: {
      en: "Achieve the lifestyle you've always wanted",
      es: "Logre el estilo de vida que siempre ha querido",
    },
  },
  homeDoctor: {
    src: homeDoctor.url,
    webp: homeDoctor.url,
    width: 800,
    height: 837,
    alt: {
      en: "Dr. Matthew Fitzer, board-certified bariatric surgeon at Virginia Bariatric Surgery in Herndon, Virginia",
      es: "El Dr. Matthew Fitzer, cirujano bariátrico certificado de Virginia Bariatric Surgery en Herndon, Virginia",
    },
    caption: {
      en: "Matthew Fitzer, M.D. — bariatric surgeon and physician",
      es: "Matthew Fitzer, M.D. — cirujano bariátrico y médico",
    },
  },
} satisfies Record<string, ProcedureMedia>;

export type ProcedureMediaKey = keyof typeof PROCEDURE_MEDIA;

/**
 * Which registry figures each Spanish procedure page renders, in DOM order.
 * Keeping the list here lets the route head(), the Spanish sitemap, and the
 * rendered <figure> markup stay in lockstep — the same guarantee the English
 * pages get from their hand-written JSON-LD blocks.
 */
export const ES_PAGE_MEDIA = {
  "/es": ["homeHero", "homeDoctor"],
  "/es/manga-gastrica": [
    "sleeveDiagramEs",
    "sleeveGraph",
    "sleeveFitzer1",
    "sleeveFitzer2",
    "sleeveFitzer3",
    "sleeveAmateur1",
    "sleeveAmateur2",
    "sleeveAmateur3",
    "sleeveRefluxNormal",
    "sleeveRefluxPostSleeve",
  ],
  "/es/bypass-gastrico": ["bypassDiagramEs", "bypassGraph"],
  "/es/cirugia-de-revision": ["revisionHub"],
  "/es/cirugia-de-revision/manga-gastrica": [
    "sleeveNormalRevision",
    "sleeveStretchedRevision",
    "sleeveUgiRefluxPreEs",
    "sleeveUgiRefluxPostEs",
  ],
  "/es/cirugia-de-revision/bypass-gastrico": ["revisionPouchContrastEs", "revisionPouchAnnotatedEs", "revisionPouchNormalEs", "revisionPouchEs"],
  "/es/cobertura-de-seguro": ["checkpointCharlie"],
  "/es/seguro/carolina-del-norte": ["checkpointCharlie"],
  "/es/banda-gastrica": ["bandDiagram"],
  "/es/cirugia-de-revision/banda-gastrica": ["bandTubing", "bandDilatedEsophagus", "bandRemoved"],
  "/es/reparacion-de-hernia-hiatal": ["hiatalNormal", "hiatalType1", "hiatalType2", "hiatalType3", "hiatalType4"],
  "/es/bypass-o-manga-gastrica": [
    "sleeveDiagram",
    "bypassDiagram",
    "bypassGraph",
    "sleeveGraph",
  ],
} satisfies Record<string, ProcedureMediaKey[]>;

export type EsMediaPath = keyof typeof ES_PAGE_MEDIA;

/** Schema.org ImageObject nodes for the figures a page renders. */
export function procedureImageObjects(
  keys: readonly ProcedureMediaKey[],
  lang: MediaLang,
  pageUrl: string,
) {
  return keys.map((key) => {
    const item = PROCEDURE_MEDIA[key];
    const aiAssisted = "aiAssisted" in item && item.aiAssisted === true;
    const absolute = item.src.startsWith("http") ? item.src : `${SITE_ORIGIN}${item.src}`;
    return {
      "@type": "ImageObject" as const,
      contentUrl: absolute,
      url: absolute,
      caption: item.caption[lang] || item.caption.en,
      name: item.alt[lang] || item.alt.en,
      description: item.alt[lang] || item.alt.en,
      width: item.width,
      height: item.height,
      inLanguage: lang === "es" ? "es-US" : "en-US",
      creditText: aiAssisted
        ? "Matthew Fitzer, MD, with AI assistance"
        : "Virginia Bariatric Surgery",
      copyrightNotice: "\u00a9 Virginia Bariatric Surgery",
      copyrightHolder: { "@type": "Organization", name: "Virginia Bariatric Surgery" },
      creator: aiAssisted
        ? { "@type": "Person", name: "Matthew Fitzer, MD" }
        : { "@type": "Organization", name: "Virginia Bariatric Surgery" },
      license: pageUrl,
      acquireLicensePage: `${SITE_ORIGIN}/contact`,
      usageInfo: `${SITE_ORIGIN}/contact`,
    };
  });
}

/** <image:image> rows for the Spanish sitemap, matching the same figures. */
export function procedureSitemapImages(keys: readonly ProcedureMediaKey[], lang: MediaLang) {
  return keys.map((key) => {
    const item = PROCEDURE_MEDIA[key];
    return {
      loc: item.src.startsWith("http") ? item.src : `${SITE_ORIGIN}${item.src}`,
      caption: item.caption[lang] || item.caption.en,
      title: item.alt[lang] || item.alt.en,
    };
  });
}
